import { createFileRoute, redirect, useParams } from '@tanstack/react-router'
import { useHead } from '@unhead/react'
import { isValidRegion } from '@/entities/region/Region'
import { useCheckAuthRedirect } from '@/features/auth/sso/lib'
import { SsoAuthentication } from '@/features/auth/sso/ui'

export const Route = createFileRoute('/_signin/$region/sso/$urlCode')({
  component: SsoConnectComponent,
  params: {
    parse: (params) => {
      const { region, urlCode } = params
      if (!region || !urlCode || !isValidRegion(region)) {
        console.error('Invalid region or parameters:', params)
        throw redirect({ to: '/login' })
      }
      return { region, urlCode }
    },
  },
})

function SsoConnectComponent() {
  useHead({
    title: 'Hello Screens - SSO',
    meta: [
      { name: 'description', content: 'Connect to Hello Screens' },
    ],
  })

  const { region, urlCode } = useParams({ from: '/_signin/$region/sso/$urlCode' })
  useCheckAuthRedirect(region)

  return (
    <SsoAuthentication region={region} urlCode={urlCode} />
  )
}
